import React from 'react'
import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux';
import { Select } from '@gpstrackit/gtc-react-controls';

const FilterServices = ({
    value,
    onChange
}) => {

    const {messages} = useIntl()
    const { servicesList } = useSelector(state => state.maintenanceVehiclesTabRedux);


  return (
    <Select
        id="services"
        label={messages['vehicleView_services']}
        value={servicesList.filter(x => value(x.id))}
        onChange={onChange}
        options={[...servicesList].sort((a, b) => {
            let av = a.title
            let bv = b.title
            if (typeof av !== 'number' || typeof bv !== 'number') {
                av = av?.toString().toLowerCase().trim()
                bv = bv?.toString().toLowerCase().trim()
            }
            return av < bv ? -1 : 1
        })}
        textField="title"
        valueField="id"
        placeholder={messages['vehicleView_select']}
        isClearable
        isMulti
        isSearchable
        menuPlacement="top"
    />
  )
}

export default FilterServices